export interface AboutPageContent {
  hero: {
    header: string;
    subheader: string;
  },
  page: {
    intro: string;
    body: string;
  }

}

export const content: AboutPageContent = {
  hero: {
    header: "About Us",
    subheader: "30 Years Specialized IT Talent Executives - focused on Cloud AppDev, Mobile Dev, DevOps, CyberSec, Infrastructure, AI/ML & OT/ICT"
  },
  page: {
    intro: "We are IT professionals with over 30 years of experience working with some of the most complex organizations in the world. \n\nEarning the trust to be your go-to talent partner is our goal.  Delivering top IT professionals is our passion.   \n\nWe are Cloud Talent Services ... \n\nStaffing your IT/OT Cloud, Security and Infrastructure",
    body: "Founded 2008, Atlanta GA\n\nRegistered MBE/DBE \n\nWe have you covered - throughout North America \n\n30+ years IT/OT experience driving Cloud Architecture and Operations Efficiencies \n\nOur Core DNA:  Enterprises & Channels (VAR, Systems Integrators and MSP's)\n\nOur methodology:  Strong Talent Screening (Technical, Cultural)\n\nSense of Urgency, Attention to Detail, High Quality Assurance \n\nWhite Glove Client/Project Approach\n\nPurposely crafted to be agile, an enabler, and a transparent part of your Talent Acquisition team\n\nWork with Engineering, Sales, Procurement, HR, VMO, RPO driving a win/win framework"
  }
}